var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDatetime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.643,
    height: 12.937,
    viewBox: "0 0 11.643 12.937",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_date_range_24px",
    d: "M6.881,7.822H5.587V9.115H6.881Zm2.587,0H8.175V9.115H9.469Zm2.587,0H10.762V9.115h1.294ZM13.35,3.294H12.7V2H11.409V3.294H6.234V2H4.941V3.294H4.294A1.288,1.288,0,0,0,3.006,4.587L3,13.643a1.293,1.293,0,0,0,1.294,1.294H13.35a1.3,1.3,0,0,0,1.294-1.294V4.587A1.3,1.3,0,0,0,13.35,3.294Zm0,10.35H4.294V6.528H13.35Z",
    transform: "translate(-3 -2)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDatetime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-datetime.dc794f001a9090c93052a19aa1c53266.svg";